interface HeroProps {
  scrollToConsultation: () => void;
}

export default function Hero({ scrollToConsultation }: HeroProps) {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        {/* Desktop Background */}
        <img
          src="https://public.readdy.ai/ai/img_res/5ccd3f217fcadd1909af17bff0288a31.jpg"
          alt="배경"
          className="hidden md:block w-full h-full object-cover object-center"
        />
        {/* Mobile Background */}
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20bright%20blue%20sky%20with%20soft%20white%20clouds%20and%20sunlight%2C%20clean%20minimalist%20aerial%20view%20of%20contemporary%20sustainable%20residential%20area%20with%20light%20blue%20and%20white%20color%20scheme%2C%20elegant%20architectural%20photography%20showing%20organized%20urban%20planning%20with%20bright%20natural%20lighting%2C%20professional%20real%20estate%20photography%20with%20soft%20blue%20tones%20and%20high%20key%20lighting%2C%20serene%20and%20sophisticated%20atmosphere%20with%20pastel%20blue%20gradient%20sky%2C%20vertical%20portrait%20composition%20for%20mobile%20devices&width=800&height=1200&seq=hero-bg-mobile-001&orientation=portrait"
          alt="배경"
          className="md:hidden w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        {/* Top Label */}
        <div className="flex items-center justify-center gap-2 mb-6">
          <div className="w-2 h-2 bg-[#D97642] rounded-full"></div>
          <span className="text-white text-sm font-medium">2026년 단 한 번의 기회</span>
        </div>

        {/* Main Copy */}
        <h1 className="mb-6">
          <div className="text-5xl md:text-6xl font-bold text-white mb-2">
            불법 건축물을 양생화해서 합법으로!
          </div>
          <div className="text-4xl md:text-5xl font-medium text-gray-200 mb-2">
            노후된 주택을 정부지원금으로 !
          </div>
        </h1>

        {/* Sub Copy */}
        <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-3xl mx-auto leading-relaxed">
          불법으로 힘들었던 재산권! 이행강제금의 굴레를 끊고 자산 가치를 회복하세요
        </p>

        {/* CTA Button */}
        <button
          onClick={scrollToConsultation}
          className="bg-[#5C4033] text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-[#4a3329] transition-all duration-300 hover:scale-105 flex items-center gap-3 mx-auto whitespace-nowrap shadow-xl"
        >
          지금 바로 무료 진단 받기
          <i className="ri-arrow-right-line text-xl"></i>
        </button>

        {/* Bottom Image Cards */}
        <div className="mt-20 flex items-center justify-center gap-6 perspective-1000">
          {/* Left Card */}
          <div className="hidden md:block w-64 bg-white rounded-2xl shadow-2xl p-4 transform rotate-[-8deg] hover:rotate-0 transition-transform duration-300">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20building%20registration%20document%20transformation%20showing%20before%20and%20after%20comparison%2C%20yellow%20violation%20stamp%20being%20removed%20to%20clean%20official%20document%2C%20administrative%20paperwork%20with%20official%20seals%20and%20stamps%2C%20professional%20document%20photography%20with%20clear%20contrast%20between%20illegal%20and%20legal%20status%2C%20organized%20layout%20with%20Korean%20text%20visible%2C%20bright%20lighting%20emphasizing%20the%20positive%20change&width=400&height=300&seq=card-left-001&orientation=landscape"
              alt="건축물대장 전후"
              className="w-full h-48 object-cover object-top rounded-lg mb-3"
            />
            <p className="text-sm font-semibold text-gray-800 text-center">불법 → 합법 전환</p>
          </div>

          {/* Center Card (Largest) - Desktop */}
          <div className="hidden md:block w-80 bg-white rounded-2xl shadow-2xl p-5 transform scale-110 hover:scale-115 transition-transform duration-300 z-10">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20old%20house%20renovation%20before%20and%20after%20comparison%2C%20aged%20residential%20building%20transformed%20into%20modern%20renovated%20home%2C%20side%20by%20side%20comparison%20showing%20weathered%20exterior%20becoming%20fresh%20and%20well-maintained%2C%20realistic%20architectural%20photography%20with%20clear%20details%20of%20improvement%2C%20natural%20daylight%20showing%20texture%20and%20material%20quality%2C%20professional%20real%20estate%20photography%20style%20with%20balanced%20composition&width=500&height=350&seq=card-center-001&orientation=landscape"
              alt="노후주택 리모델링"
              className="w-full h-56 object-cover object-top rounded-lg mb-3"
            />
            <p className="text-base font-bold text-gray-800 text-center">노후주택 개선 지원</p>
          </div>

          {/* Center Card (Mobile) */}
          <div className="md:hidden w-72 bg-white rounded-2xl shadow-2xl p-5 z-10">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20old%20house%20renovation%20before%20and%20after%20comparison%2C%20aged%20residential%20building%20transformed%20into%20modern%20renovated%20home%2C%20side%20by%20side%20comparison%20showing%20weathered%20exterior%20becoming%20fresh%20and%20well-maintained%2C%20realistic%20architectural%20photography%20with%20clear%20details%20of%20improvement%2C%20natural%20daylight%20showing%20texture%20and%20material%20quality%2C%20professional%20real%20estate%20photography%20style%2C%20mobile%20optimized%20vertical%20composition&width=600&height=450&seq=card-center-mobile-001&orientation=portrait"
              alt="노후주택 리모델링"
              className="w-full h-56 object-cover object-top rounded-lg mb-3"
            />
            <p className="text-base font-bold text-gray-800 text-center">노후주택 개선 지원</p>
          </div>

          {/* Right Card */}
          <div className="hidden md:block w-64 bg-white rounded-2xl shadow-2xl p-4 transform rotate-[8deg] hover:rotate-0 transition-transform duration-300">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20solar%20panels%20installed%20on%20Korean%20residential%20rooftop%20with%20clean%20blue%20sky%20background%2C%20photovoltaic%20system%20with%20organized%20panel%20layout%20showing%20professional%20installation%2C%20bright%20sunlight%20reflecting%20on%20solar%20cells%2C%20eco-friendly%20renewable%20energy%20concept%20with%20contemporary%20house%20architecture%2C%20aerial%20view%20showing%20efficient%20space%20utilization%20and%20sustainable%20technology%20integration&width=400&height=300&seq=card-right-002&orientation=landscape"
              alt="옥상 태양광 설치"
              className="w-full h-48 object-cover object-top rounded-lg mb-3"
            />
            <p className="text-sm font-semibold text-gray-800 text-center">옥상 태양광 설치</p>
          </div>
        </div>
      </div>
    </section>
  );
}
